import React from 'react';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { inventoryColumns } from '../../cols-definition';

function InventoryTab() {
  const tables = [
    {
      name: '',
      rows: [],
      columns: inventoryColumns()
    }
  ];
  return (
    <ErpDataTableV2
      tables={tables}
      // onRowClick={handleRowClick}
      // selectedRowId={selectedObj?.id || undefined}
    />
  );
}

export default InventoryTab;
